import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

import {
  TOKEN_HELPERS,
  sortByKey,
  filterBodyBuilder,
  handleClickPaginationItem,
  filterOrderBuilder
} from '@utils/helpers'

import { TOAST_PROPERTIES, TOAST_POSITION, rowsPerPage, TRANSLATION_OF_ROUTES } from '@global/constants'
import { MESSAGES } from '@global/message'
import { SITE } from '@routes/paths'
import {
  WrapperBreadcrumbs,
  WrapperLoading,
  FilterContainer,
  FilterContainerLeftSide,
  FilterContainerRightSide,
  WrapperHeading,
  TableWrapper,
  PaginationWrapper
} from '@global/styles'

import { Heading } from '@components/texts'
import { GhostButton } from '@components/button'
import { useWindowDimensions } from '@components/windowDimensions'
import Breadcrumbs from '@components/breadcrums'
import { useUser } from '@components/authentication/utils/hook'
import Toast from '@components/toast'
import Table from '@components/table'
import Filter from '@components/filter'
import Modal from '@components/modal'
import BadgeGroup from '@components/badgeGroup'
import SearchBar from '@components/searchBar'
import Loading from '@components/loading'
import PaginationGroup from '@components/paginationGroup'

import SELECTORS_USER from '@components/authentication/redux/selectors'

import useRedux from './redux'
import { EXPORTS_ACTIONS } from './redux/actions'
import SELECTORS from './redux/selectors'
import AddFileExportModal from './components/addExportFileModal'

import { Wrapper } from './styles'

import { columnData } from './data'

const Exports = () => {
  useRedux()
  const { device, deviceName } = useWindowDimensions()
  const dispatch = useDispatch()
  const history = useHistory()
  const { GetToken, Logout } = useUser()
  const { key } = useLocation()
  const modalRef = useRef()

  const [currentToken] = useState(GetToken())
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [selectedOption, setSelectedOption] = useState(rowsPerPage[0])
  const [itemSelected, setItemSelected] = useState()
  const [pages, setPages] = useState()
  const [totalItems, setTotalItems] = useState(0)
  const [tablelist, setTablelist] = useState([])
  const [columns, setColumns] = useState([])
  const [isShowing, setIsShowing] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [messageToast, setMessageToast] = useState({
    title: '',
    message: '',
    icon: '',
    color: ''
  })
  const [badges, setBadges] = useState([])
  const [filterData, setFilterData] = useState([])
  const [open, setOpen] = useState(false)
  const [activeFilters, setActiveFilters] = useState(null)
  const [addExportModal, setAddExportModal] = useState(false)
  const [errorFlag, setErrorFlag] = useState(false)
  const [parameters, setParameters] = useState()

  const loading = useSelector(SELECTORS.LOADING)
  const listLoading = useSelector(SELECTORS.LIST_LOADING)
  const totalPages = useSelector(SELECTORS.PAGES)
  const items = useSelector(SELECTORS.SUCCESS)
  const fields = useSelector(SELECTORS.COLUMNS)
  const allItems = useSelector(SELECTORS.TOTAL_ITEMS)
  const errorMessage = useSelector(SELECTORS.ERROR)
  const filterObject = useSelector(SELECTORS.FILTER_OBJECT)
  const jobTypes = useSelector(SELECTORS.JOBS_TYPES)

  const errorRefresh = useSelector(SELECTORS_USER.ERROR_USER_REFRESH)

  const getExports = body => {
    body.asyncJobActions = [0]
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      dispatch(EXPORTS_ACTIONS.GET({ data: body, token }))
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const handleInputChange = e => {
    if (!e?.value) delete activeFilters.filterText

    let body = activeFilters ? { ...activeFilters } : {}

    if (e?.value) {
      body = { ...body, filterText: e.value }
      setActiveFilters({
        ...activeFilters,
        filterText: e.value
      })
    }
    getExports(body)
  }

  const handleClickCloseFilters = () => {
    dispatch(EXPORTS_ACTIONS.FILTER_DATA_CLEAR())
    setShowFilter(!showFilter)
  }

  const handleClickShowFilters = () => {
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      const filterRequest = { id: 2, token }
      dispatch(EXPORTS_ACTIONS.GET_FILTER_DATA(filterRequest))
      setShowFilter(!showFilter)
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const customDataTable = itemsTable => {
    const newData = itemsTable.map(item => ({
      id: item.id,
      code: item.id,
      jobType: item.jobType,
      dateStarted: item.dateStarted,
      dateFinished: item.dateFinished,
      status: item.status
    }))
    return newData
  }

  const customHeaderDataTable = (headersData, colData) => {
    const orderedColumns = sortByKey(headersData, 'order').map(col => col.name)
    let customColumns = []
    for (let i = 0; i < orderedColumns.length; i++) {
      const wanted = Object.entries(colData).find(item => item[0] === orderedColumns[i])
      customColumns = [
        ...customColumns,
        wanted[1]
      ]
    }

    return customColumns
  }

  const handleOrderChange = (nameColumn, typeOrder) => {
    const colNames = Object.entries(columnData).find(col => col[1].name === nameColumn)[0]
    const propsForOrderBuilder = {
      filterState: activeFilters,
      setFilterState: setActiveFilters,
      columnName: colNames,
      orderByDesc: typeOrder,
      currentPageSize: selectedOption.value,
      currentPageNumber: itemSelected,
      setNewItemSelected: setItemSelected
    }
    const body = filterOrderBuilder(propsForOrderBuilder)
    getExports(body)
  }

  const handleCloseBadge = filterName => {
    const updateBadges = badges.filter(badge => badge.name !== filterName)
    setBadges(updateBadges)
    const body = filterBodyBuilder(updateBadges, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getExports(body)
  }

  const handleApplyFilter = filters => {
    setBadges(filters)
    const body = filterBodyBuilder(filters, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getExports(body)
  }

  const getExport = id => {
    history.push(`${SITE.SETTING}${SITE.EXPORTS}${SITE.EXPORT_PROFILE}/${id}`)
  }

  const handleRowClick = rowObj => getExport(rowObj.id)

  const handleToastClose = () => setIsShowing(false)

  const handleDropdownChange = e => {
    let body = null
    if (activeFilters) {
      body = { ...activeFilters }
      body = {
        ...body,
        pageNumber: 1,
        pageSize: e.value.value
      }
    } else {
      body = {
        pageNumber: 1,
        pageSize: e.value.value
      }
    }
    getExports(body)
    setSelectedOption(e.value)
    setItemSelected(0)
  }

  const renderTable = values => {
    const { currentList, columnsN, currentLoading, handleOrder, handleSelectedRow, error, showRowPointer } = values
    return (
      <Table
        list={currentList}
        columns={columnsN}
        loading={currentLoading}
        handleOrder={handleOrder}
        rowClick={handleSelectedRow}
        error={error}
        showRowPointer={showRowPointer}
        timeDate
      />
    )
  }

  const renderFilter = arrFilters => (
    <Filter
      device={device}
      close={handleClickCloseFilters}
      loadBadges={handleApplyFilter}
      filterData={arrFilters}
      isShowing={showFilter}
    />
  )

  const handleClearValues = () => {
    modalRef.current.clearValues()
  }

  const handleCloseModal = () => {
    setOpen(false)
    setAddExportModal(null)
    handleClearValues()
  }

  const handleCreateExport = () => {
    setAddExportModal({
      close: handleCloseModal,
      successfulData: handleRowClick,
      jobTypes,
      currentToken
    })
    setOpen(true)
  }

  useEffect(() => {
    dispatch(EXPORTS_ACTIONS.CLEAR())
    const body = {
      pageNumber: 1,
      pageSize: selectedOption.value,
      orderByColumn: 'Id',
      orderByDesc: true
    }
    setActiveFilters({
      orderByColumn: 'Id',
      orderByDesc: true
    })
    getExports(body)
    const fisrtCrumb = {
      link: true,
      text: TRANSLATION_OF_ROUTES.SETTING,
      url: SITE.SETTING
    }
    const lastCrumb = {
      link: true,
      text: TRANSLATION_OF_ROUTES.EXPORTS,
      url: SITE.EXPORTS
    }
    setBreadcrumbs([fisrtCrumb, lastCrumb])
  }, [key])

  useEffect(() => {
    setTablelist(customDataTable(items))
    setColumns(customHeaderDataTable(fields, columnData))
    setPages(totalPages.totalPages)
    setItemSelected(totalPages.currentPage - 1)
    setTotalItems(allItems)
  }, [items, totalPages])

  useEffect(() => {
    if (errorMessage) {
      setMessageToast({
        title: TOAST_PROPERTIES.ERROR.title,
        message: errorMessage.message || `Error ${errorMessage.status}`,
        icon: TOAST_PROPERTIES.ERROR.icon,
        color: TOAST_PROPERTIES.ERROR.color
      })
      setIsShowing(true)
      if (!errorFlag) {
        const body = {
          pageNumber: 1,
          pageSize: selectedOption.value,
          orderByColumn: 'Id',
          orderByDesc: false
        }
        getExports(body)
        setErrorFlag(true)
      } else {
        setTimeout(() => {
          history.goBack()
        }, 1500)
      }
    }
  }, [errorMessage])

  useEffect(() => {
    if (filterObject.length > 0) {
      setFilterData(filterObject)
      setParameters(filterObject.map(p => p.name))
    }
  }, [filterObject])

  useEffect(() => {
    if (errorRefresh) {
      TOKEN_HELPERS.EXPIRED_TOKEN(MESSAGES.EXPIRED_TOKEN, setIsShowing, setMessageToast, Logout)
    }
  }, [errorRefresh])

  return (
    <>
      {loading
        ? (
          <WrapperLoading>
            <Loading color='primary' size='xsmall' weight='bold' />
          </WrapperLoading>
        )
        : (
          <Wrapper>
            {breadcrumbs
              && (
              <WrapperBreadcrumbs>
                <Breadcrumbs crumbs={breadcrumbs} />
              </WrapperBreadcrumbs>
              )}
            <WrapperHeading columnStart='1' columnEnd='12' rowStart='2' rowEnd='2'>
              <Heading
                type='h2'
                weight='bold'
                align='left'
              >
                {TRANSLATION_OF_ROUTES.EXPORTS}
              </Heading>
            </WrapperHeading>
            <FilterContainer columnStart={1} columnEnd={12} rowStart={5} rowEnd={5} deviceName={deviceName}>
              <FilterContainerLeftSide deviceName={deviceName}>
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Filtro'
                  icon='filter_alt'
                  onClick={handleClickShowFilters}
                />
                {badges.length > 0 && <BadgeGroup badges={badges} handleCloseBadge={handleCloseBadge} />}
                {showFilter && (filterData.length > 0 && renderFilter(filterData))}
              </FilterContainerLeftSide>
              <FilterContainerRightSide deviceName={deviceName}>
                <SearchBar onChange={handleInputChange} value={activeFilters?.filterText} />
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Exportación +'
                  onClick={handleCreateExport}
                />
              </FilterContainerRightSide>
            </FilterContainer>
            <TableWrapper rowStart='4' rowEnd='4' columnStart='1' columnEnd='12'>
              {renderTable({
                currentList: tablelist,
                columnsN: columns,
                currentLoading: listLoading,
                handleOrder: handleOrderChange,
                handleSelectedRow: handleRowClick,
                error: !!errorMessage,
                showRowPointer: true
              })}
            </TableWrapper>
            <PaginationWrapper rowStart='5' rowEnd='5' columnStart='1' columnEnd='12'>
              {tablelist.length > 0
              && (
              <PaginationGroup
                deviceName={deviceName}
                pages={pages}
                itemSelected={itemSelected}
                handleClickPaginationItem={n => handleClickPaginationItem(
                  n, activeFilters, selectedOption.value, getExports, setItemSelected
                )}
                options={rowsPerPage}
                selectedOption={selectedOption}
                handleDropdownChange={handleDropdownChange}
                totalItems={totalItems}
                itemsPerPage={tablelist.length}
              />
              )}
            </PaginationWrapper>
            <Toast
              title={messageToast.title}
              message={messageToast.message}
              color={messageToast.color}
              icon={messageToast.icon}
              isShowing={isShowing}
              position={TOAST_POSITION.rightTop}
              onClick={handleToastClose}
              timeOut={messageToast.title === TOAST_PROPERTIES.ERROR.title ? 3000 : 2000}
            />
            <Modal
              isShowing={open}
              close={handleCloseModal}
              title='Agregar Exportación'
              minHeight='380px'
            >
              {addExportModal && (<AddFileExportModal {...addExportModal} ref={modalRef} />)}
            </Modal>
          </Wrapper>
        )}
    </>
  )
}

export default Exports
